import posthog from "posthog-js";

export function captureEventForVenue(eventName: string) {
  const venueId = new URLSearchParams(window.location.search).get("nasid");
  posthog.capture(eventName, { venueId });
}
